'use client';

import React from 'react';
import { IProduct } from '@/entities/product/model/types';
import { HStack } from '@chakra-ui/react';
import { Rating, RoundedStar } from '@smastrom/react-rating';
import Comment from '../Comments';

const CRating = ({ product }: { product?: IProduct }) => {
  return (
    <HStack pt={{ base: 0, lg: 1 }} gap={1}>
      <HStack gap={1} alignItems={'center'}>
        <Rating
          readOnly
          style={{ maxWidth: 90 }}
          value={product?.rating || 5}
          itemStyles={{
            itemShapes: RoundedStar,
            activeFillColor: 'var(--rate-color)',
            inactiveFillColor: 'var(--gray-color-400)',
          }}
        />
      </HStack>
      <Comment id={product?.id} />
    </HStack>
  );
};

export default CRating;
